import { CALCULATION_TYPE_DUCT, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_MARINE } from '../modules/calculation';

// Actions
const PREFIX = 'calculus/archive/';

export const ARCHIVE_PATCH_ITEM  = PREFIX + 'ARCHIVE_PATCH_ITEM';

const INITIAL_STATE = {};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload, useMarineProducts } = action;
  switch (type) {
    case ARCHIVE_PATCH_ITEM:
      if (!payload || !payload.id || !payload.type) {
        return state;
      }

      let archiveItemType = payload.type;
      if (payload.type === CALCULATION_TYPE_CIRCULAR_DUCT || payload.type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
        archiveItemType = CALCULATION_TYPE_DUCT;
      }

      if(useMarineProducts) {
        archiveItemType = CALCULATION_TYPE_MARINE + '-' + archiveItemType;
      }

      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          [archiveItemType]: payload
        }
      };

    default:
      return state;
  }
}

// Action Creators
export function patchArchiveItem(payload) {
  return {
    type: ARCHIVE_PATCH_ITEM,
    payload: payload
  };
}

export function getItemFromArchive(store, id, propertyName) {
  const { archive } = store.getState();
  if (!archive[id]) {
    return null;
  }

  if (archive[id][propertyName]) {
    return archive[id][propertyName];
  }
  return null;
}
